import React from 'react'
import styled from 'styled-components'
import { menuBuilderPinCopy } from 'src/constants/menuBuilderCopy'

const PINNED_COLOR = '#F53B42'

const RecipeFavouriteIcon = ({ isFavourite }) => (
  <svg width='20' height='20' viewBox='0 0 118 107' aria-hidden='true'>
    <path
      d='M32.333 6C17.608 6 5.667 17.819 5.667 32.4c0 11.77 4.666 39.707 50.602 67.947a5.26 5.26 0 0 0 5.462 0c45.936-28.24 50.602-56.176 50.602-67.947 0-14.581-11.941-26.4-26.666-26.4C70.94 6 59 22 59 22S47.059 6 32.333 6Z'
      stroke={isFavourite ? PINNED_COLOR : '#000000'}
      strokeWidth={10}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill={isFavourite ? PINNED_COLOR : '#ffffff'}
    />
  </svg>
)

const RecipePinButton = ({ pinned = false, onClick, disabled = false }) => {
  const accessibilityLabel = pinned
    ? menuBuilderPinCopy.unpinAccessibilityLabel
    : menuBuilderPinCopy.pinAccessibilityLabel

  return (
    <PinButton
      type='button'
      onClick={onClick}
      disabled={disabled}
      aria-label={accessibilityLabel}
      title={accessibilityLabel}
    >
      <RecipeFavouriteIcon isFavourite={pinned} />
    </PinButton>
  )
}

const PinButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  margin-right: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`

export default RecipePinButton
